import { Grid, Stack } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import RadioGroup from './RadioGroupComponent';

// import {
//   useFeedbackQuestion,
//   useMutationSaveFeedbackAnswer
// } from '@tms/services/tms-feedback';
// import TextInput from '@tms/components/Form/Input';
import { useForm } from 'react-hook-form';
import {
  useFeedbackQuestion,
  useMutationSaveFeedbackAnswer
} from 'redux/reducers/user/dashboard/tms-feedback';
import { toast } from 'react-toastify';
import UserTextInput from 'components/UserInput/UInput';

interface IFeedbackModal {
  dailySessionId: string;
  openFeedbackModal: boolean;
  feedbackQuestionRoutineId: number | null;
  handleCloseFeedbackModal: () => void;
  items?: any;
  //   feedbackQuestion: FeedBackQuestion;
}

interface IFeedbackAns {
  daily_session: string;
  routine_feedback_que_id: string;
  feedback_question_id: string;
  feedback_point: string;
  feedback_answer: string;
}

const FeedbackModal = ({
  dailySessionId,
  openFeedbackModal,
  feedbackQuestionRoutineId,
  handleCloseFeedbackModal,
  items
}: //   feedbackQuestions
  IFeedbackModal) => {
  const { control, reset, watch, setValue, handleSubmit } = useForm({
    defaultValues: {
      feedbackAnswers: [] as IFeedbackAns[]
    }
  });

  const feedbackAns = watch('feedbackAnswers');

  const { data: feedbackQuestion = [] } = useFeedbackQuestion(
    feedbackQuestionRoutineId?.toString() ?? '',
    'daily_session'
  );

  const { mutateAsync, isLoading } = useMutationSaveFeedbackAnswer();

  const onSubmitHandler = async () => {
    try {
      await mutateAsync(feedbackAns);
      handleCloseFeedbackModal();
      reset();
      toast.success('Daily Session Feedback Created Successfully');
    } catch (error: any) {
      reset();
      toast.error(error.response.data[0].non_field_errors);
    }
  };

  const feedbackQuestionList = React.useMemo(
    () => feedbackQuestion?.flatMap((fq) => fq.feedback_question_details) ?? [],
    [feedbackQuestion]
  );

  React.useEffect(() => {
    if (feedbackQuestionList.length) {
      const mulitpleAnswers = feedbackQuestionList
        .filter((data, index) => {
          return data.question_type == 'm';
        })
        .map((data, index) => {
          return {
            daily_session: dailySessionId,
            // daily_session: "7",
            routine_feedback_que_id:
              feedbackQuestion?.[0]?.routine_feedback_que_id?.toString() ?? '',
            feedback_question_id: data.tms_feedback_question_id,
            feedback_point: ''
          };
        });
      const shortAnswers = feedbackQuestionList
        .filter((data, index) => {
          return data.question_type == 's';
        })
        .map((data, index) => {
          return {
            daily_session: dailySessionId,
            // daily_session: "7",
            routine_feedback_que_id:
              feedbackQuestion?.[0]?.routine_feedback_que_id?.toString() ?? '',
            feedback_question_id: data.tms_feedback_question_id,
            feedback_answer: ''
          };
        });

      reset({ feedbackAnswers: [...mulitpleAnswers, ...shortAnswers] });
    }
  }, [feedbackQuestionList, feedbackQuestion, dailySessionId]);

  return (
    <div>
      <Dialog
        fullWidth={true}
        maxWidth="lg"
        open={openFeedbackModal}
        onClose={handleCloseFeedbackModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">
          <Typography variant="h4" gutterBottom>
            {items?.routine_session?.session_name}
          </Typography>{' '}
          {/* <Typography variant="h5" gutterBottom>
            Coordinate Name
          </Typography> */}
        </DialogTitle>
        <DialogContent>
          <form onSubmit={handleSubmit(onSubmitHandler)}>
            <Grid container columnSpacing={4}>
              <Grid item xs={5}></Grid>
              <Grid item xs={7} sx={{ float: 'right' }}>
                <Stack direction={'row'} display={'flex'} justifyContent={'center'}>
                  <i>In the given likert scale number 1 indicates poor and 4 indicates best.</i>
                </Stack>
                <Stack direction={'row'} justifyContent={'space-around'}>
                  {[...Array(4)].map((item, index) => (
                    <div key={index}>
                      <Typography>{index + 1}</Typography>
                    </div>
                  ))}
                </Stack>
              </Grid>
            </Grid>
            {feedbackQuestionList
              .filter((q) => q.question_type === 'm')
              .map((item, index) => {
                return (
                  <RadioGroup
                    key={index}
                    item={item}
                    selectedValue={
                      feedbackAns.find(
                        (a) => a.feedback_question_id === item.tms_feedback_question_id
                      )?.feedback_point ?? ''
                    }
                    onChange={(value) => {
                      setValue(
                        'feedbackAnswers',
                        feedbackAns.map((a, inde) => ({
                          ...a,
                          feedback_point:
                            a.feedback_question_id === item.tms_feedback_question_id
                              ? value
                              : a.feedback_point
                        }))
                      );
                    }}
                  />
                );
              })}
            <hr />

            {feedbackQuestionList
              .filter((q) => q.question_type === 's')
              .map((item, index) => {
                return (
                  <Grid container key={index} justifyContent={'space-between'}>
                    <Grid xs={6}>
                      <Typography>{item?.question}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <UserTextInput
                        label={'Answer the question'}
                        type="text"
                        name="dis"
                        control={control}
                        sx={{ height: '50px' }}
                        value={
                          feedbackAns.find(
                            (a) => a.feedback_question_id === item.tms_feedback_question_id
                          )?.feedback_answer ?? ''
                        }
                        onChange={({ target: { value } }) => {
                          setValue(
                            'feedbackAnswers',
                            feedbackAns.map((a) => ({
                              ...a,
                              //     feedback_point:
                              //   a.feedback_question_id ===
                              //   item.tms_feedback_question_id
                              //     ? value
                              //     : a.feedback_point,
                              feedback_answer:
                                a.feedback_question_id === item.tms_feedback_question_id
                                  ? value
                                  : a.feedback_answer
                            }))
                          );
                        }}
                      />
                    </Grid>
                  </Grid>
                );
              })}
            <>
              <Button
                variant="outlined"
                onClick={handleCloseFeedbackModal}
                sx={{ marginRight: '8px' }}>
                Cancel
              </Button>
              <Button variant="contained" autoFocus type="submit" disabled={isLoading}>
                {isLoading ? "Submitting.." : "Submit"}
              </Button>
            </>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default FeedbackModal;
